import React, { useEffect, useState } from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import nursingcare from "../../assets/images/nursingcare.png";
import Physiotherapy from "../../assets/images/Physiotherapy.png";
import Bedside from "../../assets/images/Bedside.png";

import nursingicon from "../../assets/images/nursingicon.png";
import physioicon from "../../assets/images/physioicon.png";
import bedsideicon from "../../assets/images/bedsideicon.png";
import { Link } from "react-router-dom"; //Link

const staticServices = [
  {
    id: 1,
    title: "Nursing Care",
    description:
      "Professional nursing support at home with experienced staff for injections, wound dressing",
    image: nursingcare,
    iconimage: nursingicon,
    link: "/home-nursingcare",
  },
  {
    id: 2,
    title: "Physiotherapy",
    description:
      "Professional nursing support at home with experienced staff for injections, wound dressing",
    image: Physiotherapy,
    iconimage: physioicon,
    link: "/home-physiotherapy",
  },
  {
    id: 3,
    title: "Bedside Attendant",
    description:
      "Professional nursing support at home with experienced staff for injections, wound dressing",
    image: Bedside,
    iconimage: bedsideicon,
    link: "/home-bedsideattendant",
  },
];

export default function Caregiver({ services = [], homeSettings = {} }) {
  const [displayServices, setDisplayServices] = useState(staticServices);

  const title = (homeSettings.home_care_title && homeSettings.home_care_title.trim() !== '') ? homeSettings.home_care_title : "Complete Caregiver Services";
  const description = (homeSettings.home_care_description && homeSettings.home_care_description.trim() !== '') ? homeSettings.home_care_description : "Compassionate nursing care, physiotherapy, and bedside assistance tailored for patient comfort, recovery, and daily healthcare support.";
  const link = (homeSettings.home_care_link && homeSettings.home_care_link.trim() !== '') ? homeSettings.home_care_link : "/contact";

  useEffect(() => {
    if (Array.isArray(services) && services.length > 0) {
      const mapped = services.map(srv => {
        let localImg = nursingcare;
        let localIcon = nursingicon;
        let localLink = "/home-nursingcare";
        
        if (parseInt(srv.service_id) === 2) {
          localImg = Physiotherapy;
          localIcon = physioicon;
          localLink = "/home-physiotherapy";
        } else if (parseInt(srv.service_id) === 3) {
          localImg = Bedside;
          localIcon = bedsideicon;
          localLink = "/home-bedsideattendant";
        }

        return {
          id: parseInt(srv.service_id),
          title: srv.service_title,
          description: srv.service_description,
          image: localImg,
          iconimage: srv.service_icon || localIcon,
          link: localLink
        };
      });
      setDisplayServices(mapped);
    } else {
      setDisplayServices(staticServices);
    }
  }, [services]);

  return (
    <div className="caregiver_section">
      <div className="container-fluid">
        <div className="section_heading row align-items-center">
          <div className="content_part col-lg-7 col-sm-8 col-12">
            <h1>{title}</h1>
            <p>{description}</p>
          </div>
          <div className="btn_part col-lg-5 col-sm-4 col-12 text-end">
            <button className="main_btn">
               <Link to={link}>
              Book Appointment <ArrowForwardIosIcon />
              </Link>
            </button>
          </div>
        </div>

        <div className="row g-3">
          {displayServices.map((service) => (
            <div className="col-lg-4 col-md-6" key={service.id}>
            <Link to={service.link}>
              <div className="service-card">
                <div className="service-body">
                  <div className="service-content">
                    <div className="service-icon">
                        <img src={service.iconimage}  alt={service.title}  /> 
                    </div> 
                    <span>{service.title}</span> 
                    <p>{service.description}</p>
                  </div>

                  <div className="service-image">
                    <img src={service.image} alt={service.title} />
                  </div>
                </div>

                <div className="service-footer">
                  <button className="book-btn">Book Now</button>

                  <button  className="arrow-btn"
                          aria-label="Go to next page">
                    <ArrowForwardIosIcon />
                  </button>
                </div>
              </div>
            </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

